<template>
  <div class="plv-ia-qn-new-list">
    <loading v-show="loading"/>
    <div v-if="list.length === 0" class="plv-ia-qn-new-list--empty">
      <polyv-icon icon="NoList" />
      <p>{{ t('plvIA.questionnaire.noList') }}</p>
    </div>
    <div v-else class="plv-ia-qn-new-list-content" @scroll="scrollHandle" >
      <div v-for="(item, index) in list" class="plv-ia-qn-new-list-card-item" :key="index">
        <div class="plv-ia-qn-new-list-card-item-header">
          <div>
            <span v-if="boolToStatus(item, STATUS.SENDED)" class="plv-ia-qn-new-list-card-item-header-status plv-ia-qn-new-list-card-item-header-status--ongoing">{{ t('plvIA.questionnaire.publishing') }}</span>
            <span v-else-if="boolToStatus(item, STATUS.FINISHED)" class="plv-ia-qn-new-list-card-item-header-status plv-ia-qn-new-list-card-item-header-status--finished">{{ t('plvIA.questionnaire.end') }}</span>
            <span v-else-if="boolToStatus(item, STATUS.NOT_SENDED)" class="plv-ia-qn-new-list-card-item-header-status plv-ia-qn-new-list-card-item-header-status--wait">{{ t('plvIA.questionnaire.waitSend') }}</span>
          </div>
          <div class="plv-ia-qn-new-list-card-item-header-title">
            {{ item.name }}
          </div>
        </div>

        <div class="plv-ia-qn-new-list-card-item-content">
          <div class="plv-ia-qn-new-list-card-item-content-detail">
            <div class="plv-ia-qn-new-list-card-item-content-count" v-html="t('plvIA.questionnaire.questionnaireFillingVolume', {total: item.total})">
            </div>
            <div class="plv-ia-qn-new-list-card-item-content-time">
              {{ formatDate(item.createdTime, 'YYYY-MM-DD hh:mm') }}
            </div>
          </div>
          <div class="plv-ia-qn-new-list-card-item-handler">
            <!--菜单1-->
            <div v-if="boolToStatus(item, STATUS.SENDED)" class="plv-ia-qn-new-list-card-item-handler-item" @click="stopQuestionnaire(item)">
              <polyv-icon class="plv-ia-qn-new-icon" icon="IconStop" />
              <span class="plv-ia-qn-new-question-color--red">{{ t('plvIA.questionnaire.stopLabel') }}</span>
            </div>
            <div v-else class="plv-ia-qn-new-list-card-item-handler-item" @click="startQuestionnaire(item)">
              <polyv-icon class="plv-ia-qn-new-icon" icon="IconSend" />
              <span>{{ boolToStatus(item, STATUS.NOT_SENDED) ? t('plvIA.questionnaire.publishLabel') : t('plvIA.questionnaire.rePublishLabel')}}</span>
            </div>
            <!--菜单2-->
            <div v-if="boolToStatus(item, STATUS.FINISHED)" class="plv-ia-qn-new-list-card-item-handler-item" @click="showStatistics(item)">
              <polyv-icon class="plv-ia-qn-new-icon" icon="IconData" />
              <span>{{ t('plvIA.questionnaire.dataLabel') }}</span>
            </div>
            <div v-else
                 class="plv-ia-qn-new-list-card-item-handler-item"
                 :class="{'plv-ia-qn-new-list-card-item-handler-item--disable': boolToStatus(item,  STATUS.SENDED)}"
                 @click="editQuestionnaire(item)">
              <polyv-icon class="plv-ia-qn-new-icon" icon="IconEdit" />
              <span>{{ t('plvIA.questionnaire.editLabel') }}</span>
            </div>
            <!--菜单3-->
            <plv-popper placement="top" trigger="hover" popper-class-name="plv-ia-qn-new-tooltip  plv-ia-qn-new-list-card-item-handler-tooltip">
              <template>
                <div class="plv-ia-qn-new-list-handle">
                  <p v-if="boolToStatus(item, STATUS.FINISHED)" @click="sendResult(item)">{{ t('plvIA.questionnaire.sendResultLabel') }}</p>
                  <p v-if="boolToStatus(item, STATUS.FINISHED)" @click="downloadStatistics(item)">{{ t('plvIA.questionnaire.exportDataLabel') }} </p>
                  <p @click="editQuestionnaire(item, true)">{{ t('plvIA.questionnaire.previewQuestionnaire') }}</p>
                  <p v-if="!boolToStatus(item, STATUS.SENDED)" @click="beforeDeleteQuestionnaire(item, index)">{{ t('plvIA.questionnaire.deleteQuestionnaire') }}</p>
                </div>
              </template>
              <div slot="reference" class="plv-ia-qn-new-list-card-item-handler-item">
                <polyv-icon class="plv-ia-qn-new-icon" icon="IconMore" />
                <span>{{ t('plvIA.questionnaire.moreLabel') }}</span>
              </div>
            </plv-popper>
          </div>
        </div>
      </div>
      <div v-if="fetching" class="plv-ia-qn-new-list-loading">
        <span class="plv-ia-loading__inner"></span>
        <span>{{ t('plvIA.questionnaire.loadingMore') }}</span>
      </div>
    </div>
    <div class="plv-ia-qn-new-list-bottom" :style="{ 'background': !(showGradient && list.length !== 0) ? 'inherit' : null}">
      <div class="plv-ia-qn-new-list-bottom-gradient" :class="{'plv-ia-qn-new-list-bottom-gradient--white': !(showGradient && list.length !== 0)}"></div>
      <button class="plv-ia-common-btn plv-ia-common-btn-blue" @click="createQuestionnaire">{{ t('plvIA.questionnaire.create') }}</button>
      <plv-popper trigger="hover" placement="top" popper-class-name="plv-ia-qn-new-tooltip">
        <template>
          <div class="plv-ia-qn-new-list-handle">
            <p @click="handleUploadClick">{{ t('plvIA.questionnaire.excelImport') }}</p>
            <p @click="downloadTemplate">{{ t('plvIA.questionnaire.excelDown') }}</p>
          </div>
        </template>
        <button slot="reference" class="plv-ia-common-btn plv-ia-common-btn-cancel plv-ia-btn-import">
          {{ t('plvIA.answerCard.import') }} <span class="plv-ia-icon--down"> > </span>
        </button>
      </plv-popper>
    </div>

    <!-- 删除后将无法恢复，确认删除？ -->
    <PopupConfirm
      ref="delete-qn-modal"
      :tips="t('plvIA.questionnaire.confirmDelTips')"
      :ensure-txt="t('plvIA.common.delete')"
      :cancel-txt="t('plvIA.common.cancel')"
      :ensure-btn-cls="'plv-ia-btn-new plv-ia-btn-orange-2 pws-vclass-btn-orange-2'"
      @ensure="deleteQuestionnaire"
      @cancel="toggleDeleteQnModal(false)"
    />

    <div v-show="false" @change="handleUploadChange">
      <input
        ref="pickFile"
        type="file"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      />
    </div>

  </div>
</template>

<script>
import Locale from '@/mixins/locale';
import { Popper } from '@polyv/polyv-ui';
import { formatDate } from '@polyv/utils/src/date';
import { STATUS, STEP } from '@/assets/app/questionnaire/helper';
import Loading from '../../../components/loading/Loading';
import PopupConfirm from '@/components/popup/Confirm';
import { debounce } from '@/assets/utils';
import { PolyvIcon } from '@polyv/icons-vue/icon';
import commonMixin from '../../app-mixin';

export default {
  name: 'QuestionnaireList',
  mixins: [Locale, commonMixin],
  components: {
    'plv-popper': Popper,
    PolyvIcon,
    Loading,
    PopupConfirm
  },
  props: {
    core: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      STEP,
      STATUS,
      loading: false,
      // 渐变区域
      showGradient: true,
      list: [],
      pageNumber: 0,
      pageTotal: 10,
      fetching: false,
      deleteQuestionnaireDate: null,
      deleteQuestionnaireIndex: -1
    };
  },
  mounted() {
    this.loading = true;
    this.getList();
    this.bindCoreListeners();
  },
  methods: {
    formatDate,
    boolToStatus(item, status) {
      return item.status === status;
    },
    createQuestionnaire() {
      this.$emit('create-questionnaire');
    },
    editQuestionnaire(item, isFullPreview = false) {
      // 发布中的问卷不能编辑
      if (this.boolToStatus(item, STATUS.SENDED) && !isFullPreview) {
        return;
      }
      this.$emit('edit-questionnaire', item, isFullPreview);
    },
    scrollHandle(e) {
      // 监听滚动距离底部40px, 隐藏渐变区域
      const isBottom = (e.target.scrollTop + e.target.clientHeight + 40) > e.target.scrollHeight;
      this.showGradient = !isBottom;
      if (isBottom) {
        this.getList();
      }
    },
    getList: debounce(async function() {
      if (this.pageNumber >= this.pageTotal && this.fetching) return;
      this.pageNumber++;
      this.fetching = true;
      try {
        const result = await this.core.getQuestionnairePageList({ pageNumber: this.pageNumber, pageSize: 10 });
        this.list = this.list.concat(result.contents);
        this.pageTotal = result.totalPages;
        this.showGradient = true;
      } finally {
        this.loading = false;
        this.fetching = false;
      }
    }, 500),
    startQuestionnaire(item) {
      this.$emit('start-questionnaire', item);
    },
    beforeDeleteQuestionnaire(questionnaire, index) {
      this.deleteQuestionnaireDate = questionnaire;
      this.deleteQuestionnaireIndex = index;
      this.toggleDeleteQnModal(true);
    },
    deleteQuestionnaire() {
      try {
        const { deleteQuestionnaireDate, deleteQuestionnaireIndex } = this;
        this.core.delete(deleteQuestionnaireDate.questionnaireId);
        this.deleteQuestionnaireDate = null;
        this.list.splice(deleteQuestionnaireIndex, 1);
        this.toggleDeleteQnModal(false);
      } catch (error) {
        this.$iaMessage.default(error.message);
      }
    },
    showStatistics(item) {
      this.$emit('show-statistics', item);
    },
    downloadStatistics(item) {
      this.$emit('download-statistics', item.questionnaireId);
    },
    stopQuestionnaire(item) {
      this.$emit('stop-questionnaire', item);
    },
    sendResult(item) {
      this.$emit('send-result', item);
    },
    downloadTemplate() {
      this.core.downloadTemplate();
    },
    handleUploadClick() {
      const input = this.$refs.pickFile;
      input.value = '';
      input.click();
    },
    async handleUploadChange() {
      const input = this.$refs.pickFile;
      const file = input.files[0];
      try {
        this.core.uploadTemplate(file);
        this.refreshList();
      } catch (e) {}
    },
    // 刷新列表
    refreshList() {
      this.loading = true;
      this.list = [];
      this.pageNumber = 0;
      this.pageTotal = 10;
      this.getList();
    },
    // 重发问卷，插入列表
    pushNewQuestionnaire(item) {
      const index = this.list.findIndex(i => i.questionnaireId === item.questionnaireId);
      if (index === -1) {
        // 头部插入
        this.list.unshift(item);
      }
    },
    handleStartMsg(msg) {
      const item = this.list.find(item => msg.questionnaireId === item.questionnaireId);
      if (item) {
        item.status = STATUS.SENDED;
      }
    },
    handleStopMsg(msg) {
      const item = this.list.find(item => msg.questionnaireId === item.questionnaireId);
      if (item) {
        item.status = STATUS.FINISHED;
      }
    },
    handleAnswerMsg(msg) {
      const item = this.list.find(item => msg.questionnaireId === item.questionnaireId);
      if (item) {
        item.total += 1;
      }
    },
    bindCoreListeners() {
      this.core
        .on('start', this.handleStartMsg)
        .on('stop', this.handleStopMsg)
        .on('answer', this.handleAnswerMsg);
      // .on('show-result', this.handleShowResultMsg)
      // .on('update-questionnaire', this.handleUpdateQuestionnaireMsg);
    },
    unbindCoreListeners() {
      this.core
        .off('start', this.handleStartMsg)
        .off('stop', this.handleStopMsg)
        .off('answer', this.handleAnswerMsg);
      //   .off('show-result', this.handelShowResultMsg);
      //   .off('update-questionnaire', this.handleUpdateQuestionnaireMsg);
    },
    // 删除问卷弹窗
    toggleDeleteQnModal(show) {
      show ? this.$refs['delete-qn-modal'].show() : this.$refs['delete-qn-modal'].hide();
    },
  },
  beforeDestroy() {
    this.unbindCoreListeners();
  }
};
</script>

<style lang="scss">
.plv-ia-qn-new-list {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #F4F4F4;
}
.plv-ia-qn-new-tooltip {
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  .plv-ia-qn-new-list-handle {
    padding: 8px;
    cursor: pointer;
    font-size: 14px;
    color: #333333;
    text-align: center;
    p + p {
      margin-top: 20px;
    }
    p:hover {
      color: var(--interactBlue);
    }
  }
}
.plv-ia-qn-new-list-card-item-handler-tooltip {
  margin-bottom: 0 !important;
  .popper__arrow {
    display: none;
  }
  .plv-ia-qn-new-list-handle {
    p + p {
      margin-top: 10px;
    }
  }
}
.plv-ia-qn-new-list--empty {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex: 1;
  img {
    width: 64px;
    height: 73px;
  }
  svg {
    width: 70px;
    height: 70px;
  }
  text-align: center;
  font-size: 14px;
  color: #757575;
}
.plv-ia-qn-new-list-bottom-gradient {
  position: absolute;
  top: -40px;
  left: 0;
  right: 0;
  content: ' ';
  height: 40px;
  background-image: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
}
.plv-ia-qn-new-list-bottom-gradient--white {
  height: 16px;
  top: -16px;
  background-image: none;
  background-color: inherit;
}
.plv-ia-qn-new-list-bottom {
  position: relative;
  padding-bottom: 16px;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  height: 32px;
  background: #FFFFFF;
  box-sizing: content-box;
  button {
    margin-left: 16px;
  }
  .plv-ia-icon--down {
    display: inline-block;
    // 旋转90度
    transform: rotate(90deg) scaleY(1.6);
    // 放大X轴
  }
}
.plv-ia-btn-import:hover {
  color: var(--interactBlue);
}

.plv-ia-qn-new-list-content {
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  overflow: auto;
  padding: 0 15px 70px;
  justify-content: space-between;
  align-content: flex-start;
  .plv-ia-qn-new-list-card-item {
    width: 336px;
    padding: 24px 16px 10px;
    height: 156px;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.05);
    border-radius: 4px;
    margin-top: 16px;
    box-sizing: border-box;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
  }
  .plv-ia-qn-new-list-card-item-header-title {
    flex: 1;
    font-size: 16px;
    color: #333333;
    line-height: 22px;
    font-weight: bold;
    padding-left: 8px;
    // 省略，点点展示
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .plv-ia-qn-new-list-card-item-header {
    display: flex;
    align-items: center;
  }
  .plv-ia-qn-new-list-card-item-header-status {
    display: inline-block;
    border: 0.5px solid;
    border-radius: 2px 2px 2px 2px;
    padding: 0 4px;
    height: 20px;
    line-height: 20px;
    font-size: 12px;
    color: white;
    &--ongoing {
      border-color: #FF7342;
      background-color: #FF7342;
    }
    &--finished {
      border-color: #9e9e9e;
      background-color: #9e9e9e;
    }
    &--wait {
      border-color: var(--interactBlue);
      background-color: var(--interactBlue);
    }
  }

  .plv-ia-qn-new-list-card-item-content {
    display: flex;
    flex-direction: column;
    flex: 1;
    .plv-ia-qn-new-list-card-item-content-detail {
      color: #757575;
      padding-top: 24px;
      padding-bottom: 20px;
      display: flex;
      font-size: 14px;
      justify-content: space-between;
      border-bottom: 1px solid #f3f3f3;
      span {
        color: var(--interactBlue);
      }
    }
  }
  .plv-ia-qn-new-list-card-item-handler {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .plv-ia-qn-new-list-card-item-handler-item {
      color: #333333;
      display: flex;
      align-items: center;
      padding-top: 8px;
      margin-top: 4px;
      cursor: pointer;
      span {
        margin-left: 4px;
      }
    }
    .plv-ia-qn-new-list-card-item-handler-item:hover {
      color: var(--interactBlue);
    }
    .plv-ia-qn-new-list-card-item-handler-item--disable {
      opacity: 0.5;
      cursor: not-allowed;
      color: #333333 !important;
    }
  }
}
.plv-ia-qn-new-list-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  margin-top: 20px;
  .plv-ia-loading__inner {
    margin-right: 8px;
    height: 13px;
    width: 13px;
    border-radius: 100%;
    border: 2px solid #2196f3;
    border-bottom-color: rgba(0, 0, 0, 0);
    background: rgba(0, 0, 0, 0) !important;
    animation: loading-rotate 1s linear 0s infinite;
  }
}

</style>
